
// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const AdminDashboard = () => {
//     const [usersData, setUsersData] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);

//     const [permissions, setPermissions] = useState({
//         add: false,
//         edit: false,
//         view: false,
//         clearScreen: false,
//         save: false,
//         approve: false,
//         print: false,
//         close: false,
//     });


//     const fetchUsersData = async () => {
//         const response = await fetch('https://erpapi.emedha.in/pages/api/user');
//         const data = await response.json();
//         setUsersData(data.users);
//     };


//     useEffect(() => {
//         fetchUsersData();
//     }, []);

//     const handleCheckboxChange = (e) => {
//         setPermissions({
//             ...permissions,
//             [e.target.name]: e.target.checked,
//         });
//     };

//     const handleOpenModal = (user) => {
//         setSelectedUser(user);

//         setPermissions({
//             add: user.add_permission === 1,
//             edit: user.edit_permission === 1,
//             view: user.view_permission === 1,
//             clearScreen: user.clear_screen_permission === 1,
//             save: user.save_permission === 1,
//             approve: user.approve_permission === 1,
//             print: user.print_permission === 1,
//             close: user.close_permission === 1,
//         });
//         fetchUsersData();
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//     };

//     const handleSavePermissions = async () => {
//         if (!selectedUser || !selectedUser.id) {
//             alert('No user selected or user ID is missing');
//             return;
//         }

//         const permissionsData = {
//             add: permissions.add ? 1 : 0,
//             edit: permissions.edit ? 1 : 0,
//             view: permissions.view ? 1 : 0,
//             clearScreen: permissions.clearScreen ? 1 : 0,
//             save: permissions.save ? 1 : 0,
//             approve: permissions.approve ? 1 : 0,
//             print: permissions.print ? 1 : 0,
//             close: permissions.close ? 1 : 0,
//         };

//         console.log('Permissions Data:', permissionsData);

//         try {
//             const response = await fetch(`https://erpapi.emedha.in/pages/api/permissions/${selectedUser.id}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(permissionsData),
//             });
//             const data = await response.json();
//             if (response.ok) {
//                 alert('Permissions updated successfully');
//                 fetchUsersData();
//                 handleCloseModal();
//             } else {
//                 alert('Error updating permissions: ' + (data.message || 'Unknown error'));
//             }
//         } catch (error) {
//             alert('An error occurred while updating permissions.');
//         }
//     };

//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const navigate = useNavigate();

//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('userData');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         console.log('Logging out...');
//         setDropdownVisible(false);
//     };



//     return (

//         <>

//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h1 className='mb-4 mt-4' style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>ADMIN DASHBOARD</h1>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button
//                                     onClick={handleLogout}
//                                     style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
//                                 >
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div className="container mt-5" >

//                 <h2 className="mb-4 text-center">All USERS DETAILS</h2>

//                 {usersData.length > 0 && (
//                     <table className="table table-striped table-bordered table-hover">
//                         <thead className="table-dark">
//                             <tr>
//                                 <th>#</th>
//                                 <th>Name</th>
//                                 <th>Phone</th>
//                                 <th>Email</th>
//                                 <th>Item Data</th>
//                                 <th>Supplier Data</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {usersData.map((user, index) => (
//                                 <tr key={index}>
//                                     <td>{index + 1}</td>
//                                     <td>{user.User_nm}</td>
//                                     <td>{user.Phone_no}</td>
//                                     <td>{user.email_id}</td>
//                                     <td>{user.item_mst === "1" ? "Yes" : "No"}</td>
//                                     <td>{user.supp_mst === "1" ? "Yes" : "No"}</td>

//                                     <td>
//                                         <button
//                                             className="btn btn-primary btn-sm"
//                                             onClick={() => handleOpenModal(user)}>
//                                             Permissions
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}

//                 {showModal && selectedUser && (
//                     <div className="modal show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
//                         <div className="modal-dialog" role="document">
//                             <div className="modal-content">
//                                 <div className="modal-header">
//                                     <h5 className="modal-title">Assign Permissions to {selectedUser.User_nm}</h5>
//                                 </div>
//                                 <div className="modal-body">
//                                     <form>
//                                         <div className="row">
//                                             <div className="col-md-6">
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="add" checked={permissions.add} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Add</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="edit" checked={permissions.edit} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Edit</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="view" checked={permissions.view} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">View</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="clearScreen" checked={permissions.clearScreen} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Clear Screen</label>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="save" checked={permissions.save} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Save</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="approve" checked={permissions.approve} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Approve</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="print" checked={permissions.print} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Print</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input type="checkbox" className="form-check-input" name="close" checked={permissions.close} onChange={handleCheckboxChange} />
//                                                     <label className="form-check-label">Close</label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </form>
//                                 </div>
//                                 <div className="modal-footer">
//                                     <button type="button" className="btn btn-primary btn-sm" onClick={handleSavePermissions}>
//                                         Save Permissions
//                                     </button>
//                                     <button type="button" className="btn btn-secondary btn-sm" onClick={handleCloseModal}>
//                                         Close
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </>
//     );
// };

// export default AdminDashboard;




// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';


// const AdminDashboard = () => {
//     const [usersData, setUsersData] = useState([]);
//     const [selectedOptions, setSelectedOptions] = useState({});
//     const [groupedMenuData, setGroupedMenuData] = useState({});
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [selectedUserId, setSelectedUserId] = useState(null);
//     const [selectedUserName, setSelectedUserName] = useState('');
//     const [userPermissions, setUserPermissions] = useState([]); 

//     const navigate = useNavigate();

//     const fetchUsersData = async () => {
//         const response = await fetch('https://erpapi.emedha.in/pages/api/user');
//         const data = await response.json();
//         setUsersData(data.users);
//     };

//     const fetchMenuData = async () => {
//         try {
//             const response = await fetch('https://erpapi.emedha.in/pages/api/api/erp-menu');
//             const data = await response.json();
//             const groupedData = data.reduce((acc, item) => {
//                 if (!acc[item.PARENT_ID]) {
//                     acc[item.PARENT_ID] = [];
//                 }
//                 acc[item.PARENT_ID].push(item);
//                 return acc;
//             }, {});
//             setGroupedMenuData(groupedData);
//         } catch (error) {
//             console.error('Error fetching ERP menu data:', error);
//         }
//     };

//     const fetchPerMissionsData = async (emp_id) => {
//         const response = await fetch('https://erpapi.emedha.in/pages/api/get/save-permissions');
//         const data = await response.json();
//         const userPermissions = data.filter(permission => permission.Emp_id === parseInt(emp_id));
//         setUserPermissions(userPermissions);
//     };

//     useEffect(() => {
//         fetchUsersData();
//         fetchMenuData();
//     }, []);

//     useEffect(() => {
//         if (selectedUserId) {
//             fetchPerMissionsData(selectedUserId);
//         }
//     }, [selectedUserId]);

//     const handleUserChange = (event) => {
//         const selectedId = event.target.value;
//         setSelectedUserId(selectedId);
//         const user = usersData.find(user => user.Emp_id === parseInt(selectedId));
//         if (user) {
//             setSelectedUserName(user.Emp_Name);
//         }
//     };

//     useEffect(() => {
//         if (selectedUserId) {
//             const permissionsMap = {};
//             userPermissions.forEach(permission => {
//                 permissionsMap[permission.sub_id] = {
//                     ADD: permission.add_permission,
//                     EDIT: permission.edit_permission,
//                     VIEW: permission.view_permission,
//                     REFRESH: permission.refresh_permission,
//                     SAVE: permission.save_permission,
//                     APPROVE: permission.approve_permission,
//                     PRINT: permission.print_permission,
//                     EXIT: permission.exit_permission,
//                 };
//             });
//             setSelectedOptions(permissionsMap);
//         }
//     }, [userPermissions, selectedUserId]);


//     const handleCheckboxChange = (menuId, action) => {
//         setSelectedOptions(prevState => ({
//             ...prevState,
//             [menuId]: {
//                 ...prevState[menuId],
//                 [action]: prevState[menuId]?.[action] ? 0 : 1, 
//             },
//         }));
//     };

//     const handleSavePermissions = async () => {
//         const permissions = Object.keys(groupedMenuData).map(parentId => {
//             const menuItems = groupedMenuData[parentId];
//             return menuItems.map(menuItem => ({
//                 PARENT_ID: menuItem.PARENT_ID,
//                 SUB_ID: menuItem.SUB_ID,
//                 ADD: selectedOptions[menuItem.SUB_ID]?.ADD || false,
//                 EDIT: selectedOptions[menuItem.SUB_ID]?.EDIT || false,
//                 VIEW: selectedOptions[menuItem.SUB_ID]?.VIEW || false,
//                 REFRESH: selectedOptions[menuItem.SUB_ID]?.REFRESH || false,
//                 SAVE: selectedOptions[menuItem.SUB_ID]?.SAVE || false,
//                 APPROVE: selectedOptions[menuItem.SUB_ID]?.APPROVE || false,
//                 PRINT: selectedOptions[menuItem.SUB_ID]?.PRINT || false,
//                 EXIT: selectedOptions[menuItem.SUB_ID]?.EXIT || false
//             }));
//         }).flat();

//         const requestData = {
//             Emp_id: selectedUserId,
//             permissions
//         };
//         try {
//             const response = await fetch('https://erpapi.emedha.in/pages/api/save-permissions', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(requestData)
//             });
//             const data = await response.json();
//             console.log(data);
//             if (response.ok) {
//                 alert('Permissions saved successfully!');
//                 setSelectedUserId(null);
//                 setSelectedUserName('');
//                 setSelectedOptions({});
//             } else {
//                 alert('Error saving permissions.');
//             }
//         } catch (error) {
//             console.error('Error saving permissions:', error);
//             alert('Error saving permissions.');
//         }
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('userData');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         setDropdownVisible(false);
//     };

//     const shouldShowCheckboxes = (menuItem) => {
//         return menuItem.PARENT_ID !== menuItem.SUB_ID;
//     };

//     return (
//         <>
//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h1 className='mb-4 mt-4' style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>ADMIN DASHBOARD</h1>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={() => setDropdownVisible(!dropdownVisible)} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button onClick={() => handleLogout()} style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer' }}>
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div className="container mt-5">
//                 <div className="row">
//                     <div className="col-5">
//                         <label htmlFor="user-select" style={{ fontSize: '1.2rem', marginRight: '10px' }}><strong>SELECT EMPLOYEE ID:</strong></label>
//                         <select id="user-select" onChange={handleUserChange} value={selectedUserId} style={{ fontSize: '1rem', padding: '5px', borderRadius: '4px', width: '50%' }}>
//                             <option value="">--Select an Employee--</option>
//                             {usersData.map(user => (
//                                 <option key={user.Emp_id} value={user.Emp_id}>{user.Emp_id}-{user.Emp_Name}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="col-5" style={{ fontSize: '1.2rem' }}>
//                         <div style={{ marginTop: '10px' }}><strong className='me-2'>SELECTED EMPLOYEE: </strong><span style={{ color: 'blue' }}>{selectedUserName}</span></div>
//                     </div>
//                     <div className="col-2">
//                         <button onClick={handleSavePermissions}>Save Permissions</button>
//                     </div>
//                 </div>
//             </div>

//             <div className="container">
//                 <table className="table table-striped table-bordered">
//                     <thead>
//                         <tr>
//                             <th>SCREEN</th>
//                             <th>ADD</th>
//                             <th>EDIT</th>
//                             <th>VIEW</th>
//                             <th>REFRESH</th>
//                             <th>SAVE</th>
//                             <th>APPROVE</th>
//                             <th>PRINT</th>
//                             <th>EXIT</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {groupedMenuData && Object.keys(groupedMenuData).map((parentId) => {
//                             const menuItems = groupedMenuData[parentId];
//                             return (
//                                 <React.Fragment key={parentId}>
//                                     <tr>
//                                         <td colSpan="10" style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                             {menuItems[0]?.PARENT_ID === menuItems[0]?.SUB_ID ? menuItems[0]?.PURPOSE : 'No Heading'}
//                                         </td>
//                                     </tr>
//                                     {menuItems.map((menuItem) => {
//                                          const isSkipped = !shouldShowCheckboxes(menuItem);
//                                          if (isSkipped) return null;
//                                         return (
//                                             <tr key={menuItem.id}>
//                                                 <td>{menuItem.PURPOSE}</td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.ADD} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'ADD')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.EDIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EDIT')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.VIEW} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'VIEW')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.REFRESH} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'REFRESH')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.SAVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'SAVE')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.APPROVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'APPROVE')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.PRINT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'PRINT')} /></td>
//                                                 <td><input type="checkbox" checked={!!selectedOptions[menuItem.SUB_ID]?.EXIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EXIT')} /></td>
//                                             </tr>
//                                         );
//                                     })}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </tbody>
//                 </table>
//             </div>
//         </>
//     );
// };

// export default AdminDashboard;


// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';


// const AdminDashboard = () => {
//     const [usersData, setUsersData] = useState([]);
//     const [selectedOptions, setSelectedOptions] = useState({});
//     const [groupedMenuData, setGroupedMenuData] = useState({});
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [selectedUserId, setSelectedUserId] = useState(null);
//     const [selectedUserName, setSelectedUserName] = useState('');
//     const [userPermissions, setUserPermissions] = useState([]);

//     const navigate = useNavigate();

//     const fetchUsersData = async () => {
//         const response = await fetch('https://erpapi.emedha.in/pages/api/user');
//         const data = await response.json();
//         setUsersData(data.users);
//     };

//     const fetchMenuData = async () => {
//         try {
//             const response = await fetch('https://erpapi.emedha.in/pages/api/api/erp-menu');
//             const data = await response.json();
//             const groupedData = data.reduce((acc, item) => {
//                 if (!acc[item.PARENT_ID]) {
//                     acc[item.PARENT_ID] = [];
//                 }
//                 acc[item.PARENT_ID].push(item);
//                 return acc;
//             }, {});
//             setGroupedMenuData(groupedData);
//         } catch (error) {
//             console.error('Error fetching ERP menu data:', error);
//         }
//     };

//     const fetchPerMissionsData = async (emp_id) => {
//         const response = await fetch('https://erpapi.emedha.in/pages/api/get/save-permissions');
//         const data = await response.json();
//         const userPermissions = data.filter(permission => permission.Emp_id === parseInt(emp_id));
//         setUserPermissions(userPermissions);
//     };

//     useEffect(() => {
//         fetchUsersData();
//         fetchMenuData();
//     }, []);

//     useEffect(() => {
//         if (selectedUserId) {
//             fetchPerMissionsData(selectedUserId);
//         }
//     }, [selectedUserId]);

//     const handleUserChange = (event) => {
//         const selectedId = event.target.value;
//         setSelectedUserId(selectedId);
//         const user = usersData.find(user => user.Emp_id === parseInt(selectedId));
//         if (user) {
//             setSelectedUserName(user.Emp_Name);
//         }
//     };

//     useEffect(() => {
//         if (selectedUserId) {
//             const permissionsMap = {};
//             userPermissions.forEach(permission => {
//                 permissionsMap[permission.sub_id] = {
//                     ADD: permission.add_permission,
//                     EDIT: permission.edit_permission,
//                     VIEW: permission.view_permission,
//                     REFRESH: permission.refresh_permission,
//                     SAVE: permission.save_permission,
//                     APPROVE: permission.approve_permission,
//                     PRINT: permission.print_permission,
//                     EXIT: permission.exit_permission,
//                 };
//             });
//             setSelectedOptions(permissionsMap);
//         }
//     }, [userPermissions, selectedUserId]);


//     const handleCheckboxChange = (menuId, action) => {
//         setSelectedOptions(prevState => ({
//             ...prevState,
//             [menuId]: {
//                 ...prevState[menuId],
//                 [action]: prevState[menuId]?.[action] ? 0 : 1,
//             },
//         }));
//     };

//     const handleSavePermissions = async () => {
//         const permissions = Object.keys(groupedMenuData).map(parentId => {
//             const menuItems = groupedMenuData[parentId];
//             return menuItems.map(menuItem => ({
//                 PARENT_ID: menuItem.PARENT_ID,
//                 SUB_ID: menuItem.SUB_ID,
//                 ADD: selectedOptions[menuItem.SUB_ID]?.ADD || false,
//                 EDIT: selectedOptions[menuItem.SUB_ID]?.EDIT || false,
//                 VIEW: selectedOptions[menuItem.SUB_ID]?.VIEW || false,
//                 REFRESH: selectedOptions[menuItem.SUB_ID]?.REFRESH || false,
//                 SAVE: selectedOptions[menuItem.SUB_ID]?.SAVE || false,
//                 APPROVE: selectedOptions[menuItem.SUB_ID]?.APPROVE || false,
//                 PRINT: selectedOptions[menuItem.SUB_ID]?.PRINT || false,
//                 EXIT: selectedOptions[menuItem.SUB_ID]?.EXIT || false
//             }));
//         }).flat();

//         const requestData = {
//             Emp_id: selectedUserId,
//             permissions
//         };
//         try {
//             const response = await fetch('https://erpapi.emedha.in/pages/api/save-permissions', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(requestData)
//             });
//             const data = await response.json();
//             console.log(data);
//             if (response.ok) {
//                 alert('Permissions saved successfully!');
//                 setSelectedUserId(null);
//                 setSelectedUserName('');
//                 setSelectedOptions({});
//             } else {
//                 alert('Error saving permissions.');
//             }
//         } catch (error) {
//             console.error('Error saving permissions:', error);
//             alert('Error saving permissions.');
//         }
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('userData');
//         sessionStorage.removeItem('userType');
//         navigate('/adminlogin');
//         setDropdownVisible(false);
//     };

//     const shouldShowCheckboxes = (menuItem) => {
//         return menuItem.PARENT_ID !== menuItem.SUB_ID;
//     };

//     return (
//         <>

//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h1 className='mb-4 mt-4' style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>ADMIN DASHBOARD</h1>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={() => setDropdownVisible(!dropdownVisible)} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button onClick={() => handleLogout()} style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer' }}>
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 <hr />

//                 <div style={{ backgroundColor: '#dbc4a9' }}>
//                     <div className="container mt-5" >
//                         <div className="row">
//                             <div className="col-5">
//                                 <label htmlFor="user-select" style={{ fontSize: '1.2rem', marginRight: '10px' }}><strong>SELECT EMPLOYEE ID:</strong></label>
//                                 <select id="user-select" onChange={handleUserChange} value={selectedUserId} style={{ fontSize: '1rem', padding: '5px', borderRadius: '4px', width: '50%' }}>
//                                     <option value="">--Select an Employee--</option>
//                                     {usersData.map(user => (
//                                         <option key={user.Emp_id} value={user.Emp_id}>{user.Emp_id}-{user.Emp_Name}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className="col-5" style={{ fontSize: '1.2rem' }}>
//                                 <div style={{ marginTop: '10px' }}><strong className='me-2'>SELECTED EMPLOYEE: </strong><span style={{ color: 'blue' }}>{selectedUserName}</span></div>
//                             </div>
//                             <div className="col-2">
//                                 <button onClick={handleSavePermissions}>Save Permissions</button>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="container" style={{ backgroundColor: '#dbc4a9', padding: '20px' }}>
//                         <table className="table table-striped table-bordered" style={{ backgroundColor: '#dbc4a9', borderCollapse: 'collapse' }}>
//                             <thead style={{ backgroundColor: '#dbc4a9', color: '#333' }}>
//                                 <tr>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>SCREEN</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>ADD</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>EDIT</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>VIEW</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>REFRESH</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>SAVE</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>APPROVE</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>PRINT</th>
//                                     <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>EXIT</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {groupedMenuData && Object.keys(groupedMenuData).map((parentId) => {
//                                     const menuItems = groupedMenuData[parentId];
//                                     return (
//                                         <React.Fragment key={parentId}>
//                                             <tr>
//                                                 <td colSpan="10" style={{ fontWeight: 'bold', fontSize: '1.2rem', backgroundColor: '#dbc4a9', color: '#333' }}>
//                                                     {menuItems[0]?.PARENT_ID === menuItems[0]?.SUB_ID ? menuItems[0]?.PURPOSE : 'No Heading'}
//                                                 </td>
//                                             </tr>
//                                             {menuItems.map((menuItem) => {
//                                                 const isSkipped = !shouldShowCheckboxes(menuItem);
//                                                 if (isSkipped) return null;
//                                                 return (
//                                                     <tr key={menuItem.id} style={{ backgroundColor: '#dbc4a9' }}>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>{menuItem.PURPOSE}</td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.ADD} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'ADD')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.EDIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EDIT')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.VIEW} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'VIEW')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.REFRESH} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'REFRESH')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.SAVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'SAVE')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.APPROVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'APPROVE')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.PRINT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'PRINT')} /></td>
//                                                         <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.EXIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EXIT')} /></td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </React.Fragment>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>


//                 </div>

//             </div>
//         </>
//     );
// };

// export default AdminDashboard;




import React, { useState, useEffect } from 'react';
import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import { FaCheckCircle, FaSpinner, FaTimesCircle } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import Select from 'react-select';

const AdminDashboard = () => {
    const [usersData, setUsersData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [groupedMenuData, setGroupedMenuData] = useState({});
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUserName, setSelectedUserName] = useState('');
    const [selectedflag, setSelectedFlag] = useState('');
    const [selectemail, setSelectedEmail] = useState('');
    const [userPermissions, setUserPermissions] = useState([]);
    const [Name, setName] = useState('');

    const navigate = useNavigate();

    const fetchUsersData = async () => {
        const response = await fetch('https://erpapi.emedha.in/pages/api/user');
        const data = await response.json();
        setUsersData(data.users);
    };

    const fetchMenuData = async () => {
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/api/erp-menu');
            const data = await response.json();
            const groupedData = data.reduce((acc, item) => {
                if (!acc[item.PARENT_ID]) {
                    acc[item.PARENT_ID] = [];
                }
                acc[item.PARENT_ID].push(item);
                return acc;
            }, {});
            setGroupedMenuData(groupedData);
        } catch (error) {
            console.error('Error fetching ERP menu data:', error);
        }
    };

    const fetchPerMissionsData = async (emp_id) => {
        const response = await fetch('https://erpapi.emedha.in/pages/api/get/save-permissions');
        const data = await response.json();
        const userPermissions = data.filter(permission => permission.Emp_id === parseInt(emp_id));
        setUserPermissions(userPermissions);
    };

    useEffect(() => {
        fetchUsersData();
        fetchMenuData();
    }, []);

    useEffect(() => {
        if (selectedUserId) {
            fetchPerMissionsData(selectedUserId);
        }
    }, [selectedUserId]);

    const handleUserChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        setSelectedUserId(selectedId);

        const user = usersData.find(user => user.Emp_id === parseInt(selectedId));
        if (user) {
            setSelectedUserName(user.Emp_Name);
            setSelectedFlag(user.Flag);
        }
    };

    const options = usersData.map(user => ({
        value: user.Emp_id,
        label: `${user.Emp_id}-${user.Emp_Name}`
    }));

    useEffect(() => {
        if (selectedUserId) {
            const permissionsMap = {};
            userPermissions.forEach(permission => {
                permissionsMap[permission.sub_id] = {
                    ADD: permission.add_permission,
                    EDIT: permission.edit_permission,
                    VIEW: permission.view_permission,
                    REFRESH: permission.refresh_permission,
                    SAVE: permission.save_permission,
                    APPROVE: permission.approve_permission,
                    PRINT: permission.print_permission,
                    EXIT: permission.exit_permission,
                };
            });
            setSelectedOptions(permissionsMap);
        }
    }, [userPermissions, selectedUserId]);


    const handleCheckboxChange = (menuId, action) => {
        setSelectedOptions(prevState => ({
            ...prevState,
            [menuId]: {
                ...prevState[menuId],
                [action]: prevState[menuId]?.[action] ? 0 : 1,
            },
        }));
    };

    const handleSavePermissions = async () => {
        const permissions = Object.keys(groupedMenuData).map(parentId => {
            const menuItems = groupedMenuData[parentId];
            return menuItems.map(menuItem => ({
                PARENT_ID: menuItem.PARENT_ID,
                SUB_ID: menuItem.SUB_ID,
                ADD: selectedOptions[menuItem.SUB_ID]?.ADD || false,
                EDIT: selectedOptions[menuItem.SUB_ID]?.EDIT || false,
                VIEW: selectedOptions[menuItem.SUB_ID]?.VIEW || false,
                REFRESH: selectedOptions[menuItem.SUB_ID]?.REFRESH || false,
                SAVE: selectedOptions[menuItem.SUB_ID]?.SAVE || false,
                APPROVE: selectedOptions[menuItem.SUB_ID]?.APPROVE || false,
                PRINT: selectedOptions[menuItem.SUB_ID]?.PRINT || false,
                EXIT: selectedOptions[menuItem.SUB_ID]?.EXIT || false
            }));
        }).flat();

        const requestData = {
            Emp_id: selectedUserId,
            permissions
        };
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/save-permissions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });
            const data = await response.json();
            console.log(data);
            if (response.ok) {
                alert('Permissions saved successfully!');
                window.location.reload();
                setSelectedUserId(null);
                setSelectedUserName('');
                setSelectedOptions({});
            } else {
                alert('Error saving permissions.');
            }
        } catch (error) {
            console.error('Error saving permissions:', error);
            alert('Error saving permissions.');
        }
    };

    const handleLogout = () => {
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('userType');
        navigate('/adminlogin');
        setDropdownVisible(false);
    };

    const shouldShowCheckboxes = (menuItem) => {
        return menuItem.PARENT_ID !== menuItem.SUB_ID;
    };

    const [showStatusModal, setShowStatusModal] = useState(false);
    const [newFlag, setNewFlag] = useState(0);

    const handleStatusChange = async () => {
        console.log('Selected User ID:', selectedUserId1);
        if (!selectedUserId1) {
            alert("Please select an employee first!");
            return;
        }

        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/api/update-status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Emp_id: selectedUserId1,
                    newFlag: newFlag,
                }),
            });
            const result = await response.json();
            if (response.ok) {
                alert('Status updated successfully!');
                window.location.reload();
                fetchUsersData();
                setShowStatusModal(false);
            } else {
                alert(result.message || 'Error updating status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            alert('Error updating status');
        }
    };

    const [selectedUserId1, setSelectedUserId1] = useState('');
    const [selectedflag1, setSelectedFlag1] = useState('');
    useEffect(() => {
        if (selectedUserId1) {
            const selectedUser = usersData.find(user => user.Emp_id === parseInt(selectedUserId1));
            if (selectedUser) {
                setName(selectedUser.Emp_Name);
                setSelectedEmail(selectedUser.email_id);
                setSelectedFlag1(selectedUser.Flag);
            }
        }
    }, [selectedUserId1, usersData]);

    const handleUserChangee = (selectedOption) => {
        console.log(selectedOption);
        const selectedId = selectedOption ? selectedOption.value : '';
        setSelectedUserId1(selectedId);

        const user = usersData.find(user => user.Emp_id === parseInt(selectedId));
        if (user) {
            setName(user.Emp_Name);
            setSelectedEmail(user.email_id);
            setSelectedFlag1(user.Flag);
        }
    };

    const userOptions = usersData.map(user => ({
        value: user.Emp_id,
        label: `${user.Emp_id} - ${user.Emp_Name}`,
    }));

    return (
        <>
            <div style={{ backgroundColor: "#dbc4a9" }}>
                <div className="container d-flex justify-content-between align-items-center">
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h1 className='mb-4 mt-4' style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>ADMIN DASHBOARD</h1>
                    <div className="position-relative">
                        <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={() => setDropdownVisible(!dropdownVisible)} />
                        {dropdownVisible && (
                            <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                                <button onClick={() => handleLogout()} style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer' }}>
                                    <BsBoxArrowRight style={{ marginRight: '5px' }} />
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <hr />

                <div className="container text-end" style={{ border: '2px solid black', padding: '1px' }}>
                    <strong>CHANGE EMPLOYEE's STATUS: </strong>
                    <button className="my-2 mx-2 btn btn-success btn-sm" style={{ border: '2px solid black', padding: '10px' }} onClick={() => setShowStatusModal(true)}>
                        STATUS
                    </button>
                    <button className="my-2 mx-2 btn btn-sm" style={{ border: '2px solid black', padding: '10px' }} onClick={() => window.location.reload()}>
                        <HiOutlineRefresh size={20} />
                    </button>
                </div>


                <div style={{ backgroundColor: '#dbc4a9' }}>
                    <div className="container mt-2" style={{ border: '2px solid black', padding: '10px', }}>
                        <div className="row d-flex align-items-center">
                            <div className="col-auto d-flex align-items-center">
                                <label htmlFor="user-select" style={{ fontSize: '1.2rem', marginRight: '10px' }}>
                                    <strong>SELECT EMPLOYEE ID:</strong>
                                </label>
                                <Select
                                    id="user-select"
                                    onChange={handleUserChange}
                                    value={options.find(option => option.value === selectedUserId)}
                                    options={options}
                                    placeholder="--Select an Employee--"
                                    styles={{
                                        menu: (provided) => ({ ...provided, width: '100%',  overflowY: 'auto', }),
                                        control: (provided) => ({ ...provided, fontSize: '1rem', border: '2px solid black', backgroundColor: 'transparent', padding: '5px', borderRadius: '4px' }),
                                    }}
                                />
                            </div>

                            <div className="col-auto d-flex align-items-center" style={{ fontSize: '1.2rem' }}>
                                <strong className="me-2">SELECTED EMPLOYEE: <span style={{ color: 'blue' }}>{selectedUserName}</span></strong>
                            </div>

                            <div className="col-auto d-flex align-items-center" style={{ fontSize: '1.2rem' }}>
                                <strong className="me-2">STATUS:
                                    <span style={{ color: selectedflag === 0 ? 'green' : selectedflag === 1 ? 'red' : 'blue', marginLeft: '10px' }}>
                                        {selectedflag === 0 ? (
                                            <>
                                                <FaCheckCircle style={{ color: 'green', marginRight: '8px' }} />
                                                Active
                                            </>
                                        ) : selectedflag === 1 ? (
                                            <>
                                                <FaTimesCircle style={{ color: 'red', marginRight: '8px' }} />
                                                Inactive
                                            </>
                                        ) : (
                                            <>
                                                <FaSpinner style={{ color: 'blue', marginRight: '8px' }} className="spin" />
                                                Loading...
                                            </>
                                        )}
                                    </span>
                                </strong>
                            </div>

                            <div className="col-auto ms-auto d-flex align-items-center">
                                <button style={{ border: '2px solid black', padding: '10px' }} className="btn btn-primary btn-sm" onClick={handleSavePermissions}>
                                    Save Permissions
                                </button>
                            </div>
                        </div>

                    </div>

                    <div className="container" style={{ backgroundColor: '#dbc4a9', padding: '20px', border: '2px solid black', }}>
                        <table className="table table-striped table-bordered" style={{ backgroundColor: '#dbc4a9', borderCollapse: 'collapse' }}>
                            <thead style={{ backgroundColor: '#dbc4a9', color: '#333' }}>
                                <tr>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>SCREEN</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>ADD</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>EDIT</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>VIEW</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>REFRESH</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>SAVE</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>APPROVE</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>PRINT</th>
                                    <th style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>EXIT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupedMenuData && Object.keys(groupedMenuData).map((parentId) => {
                                    const menuItems = groupedMenuData[parentId];
                                    return (
                                        <React.Fragment key={parentId}>
                                            <tr>
                                                <td colSpan="10" style={{ fontWeight: 'bold', fontSize: '1.2rem', backgroundColor: '#dbc4a9', color: '#333' }}>
                                                    {menuItems[0]?.PARENT_ID === menuItems[0]?.SUB_ID ? menuItems[0]?.PURPOSE : 'No Heading'}
                                                </td>
                                            </tr>
                                            {menuItems.map((menuItem) => {
                                                const isSkipped = !shouldShowCheckboxes(menuItem);
                                                if (isSkipped) return null;
                                                return (
                                                    <tr key={menuItem.id} style={{ backgroundColor: '#dbc4a9' }}>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}>{menuItem.PURPOSE}</td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.ADD} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'ADD')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.EDIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EDIT')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.VIEW} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'VIEW')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.REFRESH} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'REFRESH')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.SAVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'SAVE')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.APPROVE} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'APPROVE')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.PRINT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'PRINT')} /></td>
                                                        <td style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }}><input type="checkbox" style={{ outline: 'none', backgroundColor: '#dbc4a9', border: '1px solid #aaa', padding: '5px' }} checked={!!selectedOptions[menuItem.SUB_ID]?.EXIT} onChange={() => handleCheckboxChange(menuItem.SUB_ID, 'EXIT')} /></td>
                                                    </tr>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <>
                {showStatusModal && (
                    <div className="modal fade show" style={{ display: 'block' }} role="dialog" aria-labelledby="statusModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header" style={{ background: 'linear-gradient(135deg, #f0e4d7, #dbc4a9)' }}>
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <h5 className="modal-title" id="statusModalLabel">Select Status</h5>
                                        <button type="button" id="status" className={`btn btn-sm ${selectedflag1 === 0 ? 'btn-success' : selectedflag1 === 1 ? 'btn-danger' : 'btn-primary'}`}>
                                            {selectedflag1 === 0 ? 'Active' : selectedflag1 === 1 ? 'Inactive' : 'Loading...'}
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label htmlFor="user-select" className="font-weight-bold">Select an Employee</label>
                                        <Select
                                            id="user-select"
                                            value={userOptions.find(option => option.value === selectedUserId1)}
                                            onChange={handleUserChangee}
                                            options={userOptions}
                                            placeholder="Select an Employee"
                                            styles={{
                                                menu: (provided) => ({ ...provided, width: '100%', maxHeight: '200px', overflowY: 'auto', }),
                                            }}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="name" className="font-weight-bold">Name</label>
                                        <input type="text" id="name" value={Name || ''} readOnly className="form-control-plaintext text-primary" disabled />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email" className="font-weight-bold">Email</label>
                                        <input type="email" id="email" value={selectemail || ''} readOnly className="form-control-plaintext text-primary" disabled />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="status" className="font-weight-bold">Status</label>
                                        <input type="text" id="status" value={selectedflag1 === 0 ? 'Active' : selectedflag1 === 1 ? 'Inactive' : 'Loading...'} readOnly className={`form-control-plaintext ${selectedflag1 === 0 ? 'text-success' : selectedflag1 === 1 ? 'text-danger' : 'text-primary'}`} disabled />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="status-select" className="font-weight-bold">Update Status:</label>
                                        <select id="status-select" onChange={(e) => setNewFlag(parseInt(e.target.value))} value={newFlag} className="form-control">
                                            <option value={0}>Active</option>
                                            <option value={1}>Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success btn-sm" onClick={handleStatusChange}>Update Status</button>
                                    <button type="button" className="btn btn-danger btn-sm" data-dismiss="modal" onClick={() => setShowStatusModal(false)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </>
        </>
    );
};

export default AdminDashboard;

